import React from "react";
import { useState, useEffect, useCallback, useRef } from "react";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import frame from "../../assets/svg/Frame.svg";
import clock from "../../assets/svg/clock.svg";
import org from "../../assets/svg/org.svg";
import proof from "../../assets/svg/Proof.svg";
import pov from "../../assets/svg/pov.svg";
import close from "../../assets/svg/close-modal.svg";
import meet from "../../assets/svg/meet.svg";
import approval from "../../assets/svg/approval.svg";
import cf from "../../assets/svg/cf.svg";
import cus from "../../assets/svg/cus.svg";
import df from "../../assets/svg/df.svg";
import Attachment from "../../assets/svg/attachment.svg";
import Upload from "../../assets/svg/gateoutupload.svg";
import Camera from "../../assets/svg/gateoutcamera.svg";
import filt from "../../assets/svg/filt.svg";
import que from "../../assets/svg/que.svg";
import arrow from "../../assets/svg/arrow.svg";
import gtin from "../../assets/svg/gtin.svg";
import gtot from "../../assets/svg/gtot.svg";
import scheule from "../../assets/svg/scheule.svg";
import search from "../../assets/svg/search.svg";
import vector from "../../assets/svg/Vector.svg";
import vectorup from "../../assets/svg/Vector up.svg";
import qr from "../../assets/svg/qr.svg";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import p1 from "../../assets/svg/p1.svg";
import p2 from "../../assets/svg/p2.svg";
import dw from "../../assets/svg/dw.svg";
import pn from "../../assets/svg/pn.svg";
import bu from "../../assets/svg/bu.svg";
import lo from "../../assets/svg/lo.svg";
import ph from "../../assets/svg/ph.svg";
import mail from "../../assets/svg/mail.svg";
import mp from "../../assets/svg/mp.svg";
import ent from "../../assets/svg/ent.svg";
import TopBar from "../topbar/TopBar";
import { get } from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../components/vehicle/vehiclelist.css";
import {
  gateOutVehicleApi,
  getDepartmentFilterApi,
  getLocationFilterApi,
} from "./vehicle-api";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import QueueApproveModal from "../modal-dialog/queue-approve-modal";
import CheckListFailedAdminModal from "../modal-dialog/checklist-failed-admin-modal";
import GateOutModal from "../modal-dialog/gate-out-modal";
import {
  checkListFailsUpdateApi,
  gateInApprovedCheckListApi,
  gateOutApi,
  getEnabledFieldApi,
  queueStatusUpdateApi,
  uploadGateInOutAttachmentApi,
  vehicleGateInApprovedCheckListApi,
} from "../visitor/visitor-api";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";
import GenerateQRModal from "../modal-dialog/generate-qr-modal";
import { useGlobal } from "../../GlobalContext.js";
import gate from "../../assets/svg/gate-details.svg";
import PoweredBy from "../common/poweredBy.jsx";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import Loader from "../common/Loader";

const Vehiclelist = () => {
  const {
    vehicleCurrentTab,
    setVehicleCurrentTab,
    vehicleLocation,
    setVehicleLocation,
    vehicleDepartment,
    setVehicleDepartment,
    vehicleDateRange,
    setVehicleDateRange,
    vehicleGateInRange,
    setVehicleGateInRange,
    vehicleGateOutRange,
    setVehicleGateOutRange,
  } = useGlobal();

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const isFirstRun = useRef(true);
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [vehicleDetails, setVehicleDetails] = useState({});
  const [showQueueApproveModal, setShowQueueApproveModal] = useState(false);
  const [showGateOutDetails, setShowGateOutDetails] = useState(false);
  const [showGenerateQRCode, setShowGenerateQRCode] = useState(false);
  const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] =
    useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [isGateInAttachmentRequired, setIsGateInAttachmentRequired] =
    useState(false);
  const [gateInAttachmentRequired, setGateInAttachmentRequired] = useState("");
  const [isGateInInvoiceRequired, setIsGateInInvoiceRequired] = useState(false);
  const [gateInInvoiceRequired, setGateInInvoiceRequired] = useState("");
  const [isGateInRemarksRequired, setIsGateInRemarksRequired] = useState(false);
  const [gateInRemarksRequired, setGateInRemarksRequired] = useState("");

  const [isGateOutAttachmentRequired, setIsGateOutAttachmentRequired] =
    useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [remarks, setRemarks] = useState("");

  //sorting
  const [sortByField, setSortByField] = useState("");
  const [sortBy, setSortBy] = useState("");

  //search
  const [term, setTerm] = useState("");

  const [showCustomColumPopup, setShowCustomColumPopup] = useState(false);
  const [listingColumns, setListingColumns] = useState([
    { label: "S.No", status: true, value: "code" },
    { label: "Driver Name", status: true, value: "driver_name" },
    { label: "Gate", status: true, value: "gate" },
    { label: "Gate In", status: true, value: "in_time" },
    { label: "Gate Out", status: true, value: "out_time" },
    { label: "Vehicle Number", status: true, value: "vehicle_number" },
    { label: "Mobile Number", status: true, value: "mobile_number" },
    { label: "Email", status: false, value: "email" },
    { label: "Reporting Person", status: false, value: "responsible_pername" },
    // { "label": "Registered Date", "status": false, "value": "registered_date" },
    // { "label": "Approved Date", "status": false, "value": "approved_date" },
    // { "label": "Checklist Failed Date", "status": false, "value": "checklist_failed_date" },
    // { "label": "Scheduled Date", "status": false, "value": "scheduled_date" },
    // { "label": "Rejected Date", "status": false, "value": "rejected_date" },
  ]);

  // Define button options
  const buttons = [
    { label: "Queue", value: "queue" },
    { label: "Approved", value: "approved" },
    { label: "Checklist Failed", value: "checklist-failed" },
    { label: "Gate In", value: "gatein" },
    { label: "Rejected", value: "rejected" },
    { label: "Completed", value: "completed" },
  ];
  const [approveCount, setApproveCount] = useState(0);
  const [gateInCount, setGateInCount] = useState(0);
  const [schedulesCount, setSchedulesCount] = useState(0);
  const [queueCount, setQueueCount] = useState(0);
  const [checkListCount, setCheckListCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);

  // State for active button
  const [activeButton, setActiveButton] = useState(vehicleCurrentTab);
  const [enabledFields, setEnabledFields] = useState([]);

  // Button click handler
  const handleButtonClick = (buttonValue) => {
    setActiveButton(buttonValue); // Just update state
    setVehicleCurrentTab(buttonValue);
  };

  //Reset Filter
  const handleReset = () => {
    setLocation("");
    setDepartment([]);
    setDateRange([null, null]);
    setGateInRange([null, null]);
    setGateOutRange([null, null]);
    getListData(term, true);
  };

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % vehicles.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`,
    );
    setItemOffset(event.selected);
  }, []);

  //List
  const [list, setList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  //modal
  const [isOpenGateInAttachment, setIsOpenGateInAttachment] = useState(false);

  const openModal = () => setIsOpenGateInAttachment(true);
  const closeModal = () => setIsOpenGateInAttachment(false);
  const [imageList, setImageList] = useState([]);

  const handleUploadImageOut = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) =>
      ["image/jpeg", "image/png", "image/jpg"].includes(file.type),
    );

    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result;
        setImageList((prev) => {
          // Add only if it's not already in the list
          if (!prev.includes(base64Data)) {
            return [...prev, base64Data];
          } else {
            return prev;
          }
        });
      };
      reader.readAsDataURL(file);
    });

    e.target.value = ""; // Clear file input
  };

  //capture
  const [photoOut, setPhotoOut] = useState(false);
  const videoOutRef = useRef(null);
  const canvasOutRef = useRef(null);

  const openOutModal = () => {
    //setCapturedImageOut(null);
    setPhotoOut(true);
  };
  const closeOutModal = () => {
    stopCameraOut();
    setPhotoOut(false);
  };

  const startCameraOut = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoOutRef.current) {
        videoOutRef.current.srcObject = stream;
        videoOutRef.current.play();
      }
    } catch (err) {
      console.error("Camera access error:", err);
      alert("Please allow camera access.");
      setPhotoOut(false);
    }
  };

  const stopCameraOut = () => {
    if (videoOutRef.current && videoOutRef.current.srcObject) {
      videoOutRef.current.srcObject
        .getTracks()
        .forEach((track) => track.stop());
      videoOutRef.current.srcObject = null;
    }
  };

  // const captureImageOut = () => {
  //   const video = videoOutRef.current;
  //   const canvas = canvasOutRef.current;

  //   canvas.width = 420;
  //   canvas.height = 250;

  //   const ctx = canvas.getContext("2d");
  //   const videoWidth = video.videoWidth;
  //   const videoHeight = video.videoHeight;
  //   const targetAspect = 420 / 250;
  //   const videoAspect = videoWidth / videoHeight;

  //   let sx, sy, sw, sh;

  //   if (videoAspect > targetAspect) {
  //     sh = videoHeight;
  //     sw = sh * targetAspect;
  //     sx = (videoWidth - sw) / 2;
  //     sy = 0;
  //   } else {
  //     sw = videoWidth;
  //     sh = sw / targetAspect;
  //     sx = 0;
  //     sy = (videoHeight - sh) / 2;
  //   }

  //   ctx.drawImage(video, sx, sy, sw, sh, 0, 0, 420, 250);
  //   const imageDataURL = canvas.toDataURL("image/png");
  //   stopCameraOut();
  //   setCapturedImageOut(imageDataURL);
  //   setUploadedImageOut(null);
  // };

  const captureImageOut = () => {
    const video = videoOutRef.current;
    const canvas = canvasOutRef.current;

    canvas.width = 420;
    canvas.height = 250;

    const ctx = canvas.getContext("2d");
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;
    const targetAspect = 420 / 250;
    const videoAspect = videoWidth / videoHeight;

    let sx, sy, sw, sh;
    if (videoAspect > targetAspect) {
      sh = videoHeight;
      sw = sh * targetAspect;
      sx = (videoWidth - sw) / 2;
      sy = 0;
    } else {
      sw = videoWidth;
      sh = sw / targetAspect;
      sx = 0;
      sy = (videoHeight - sh) / 2;
    }

    ctx.drawImage(video, sx, sy, sw, sh, 0, 0, 420, 250);
    const imageDataURL = canvas.toDataURL("image/png");

    stopCameraOut();
    setImageList((prev) => [...prev, imageDataURL]);
    setPhotoOut(false);
  };

  useEffect(() => {
    if (photoOut) startCameraOut();
    return () => stopCameraOut();
  }, [photoOut]);

  const removeImage = (indexToRemove) => {
    setImageList((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  // location , department , status
  const location = vehicleLocation;
  const setLocation = setVehicleLocation;
  const department = vehicleDepartment;
  const setDepartment = setVehicleDepartment;

  const handleDepartmentChange = (option) => {
    setDepartment((prev) => {
      const exists = prev.some((item) => item.value === option.value);
      if (exists) {
        return prev.filter((item) => item.value !== option.value);
      }
      return [...prev, option];
    });
  };

  //date range
  const dateRange = vehicleDateRange;
  const setDateRange = setVehicleDateRange;
  const [from_date, to_date] = dateRange;

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formattedFromDate = formatDate(from_date);
  const formattedToDate = formatDate(to_date);

  // State for Gate In date range
  const gateInRange = vehicleGateInRange;
  const setGateInRange = setVehicleGateInRange;
  const [from_gate_in, to_gate_in] = gateInRange;

  const formattedFromGateIn = formatDate(from_gate_in);
  const formattedToGateIn = formatDate(to_gate_in);

  // State for Gate Out date range
  const gateOutRange = vehicleGateOutRange;
  const setGateOutRange = setVehicleGateOutRange;
  const [from_gate_out, to_gate_out] = gateOutRange;

  const formattedFromGateOut = formatDate(from_gate_out);
  const formattedToGateOut = formatDate(to_gate_out);

  const [data, setData] = useState({
    gateInCount: 0,
    gateOutCount: 0,
    scheduleCount: 0,
    schedulePercentage: 0,
    gateInPercentage: 0,
    gateOutPercentage: 0,
  });

  //const response = await get(apiUrl + "visitors?limit="+itemsPerPage+"&skip="+itemOffset+"&from_gate_in="+from_gate_in+"&to_gate_in="+to_gate_in+"&from_gate_out="+from_gate_out+"&to_gate_out="+to_gate_out+"&department_id="+department+"&location_id="+location+"&fromCreatedDate="+from_date+"&toCreatedDate="+to_date+"&status="+status+"&type="+activeButton).then(async (response) => {

  const [vehicles, setVehicles] = useState([]);

  const [locations, setLocations] = useState([]);

  const [departments, setDepartments] = useState([]);

  /*  useEffect(() => {
      if(vehicleCurrentTab!==""){
        setActiveButton(vehicleCurrentTab)
      }
    }, []);
 */
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getListData(term);
    }, 500); // debounce for 500ms

    return () => clearTimeout(delayDebounce); // cleanup on next keystroke
  }, [term]); // trigger when `term` changes

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    /*  if(itemOffset && itemsPerPage && sortByField && sortBy && activeButton) */
    getListData(term); // Keep current search value while sorting
  }, [itemOffset, itemsPerPage, sortByField, sortBy, activeButton]);

  //List Api
  const getListData = async (term, clearFilters = false) => {
    setIsLoading(true);
    setVehicles([]);
    const deptId = clearFilters
      ? ""
      : department.map((item) => item.value).join(",");
    const locId = clearFilters ? "" : location;
    const fDate = clearFilters ? "" : formattedFromDate;
    const tDate = clearFilters ? "" : formattedToDate;
    const fGateIn = clearFilters ? "" : formattedFromGateIn;
    const tGateIn = clearFilters ? "" : formattedToGateIn;
    const fGateOut = clearFilters ? "" : formattedFromGateOut;
    const tGateOut = clearFilters ? "" : formattedToGateOut;
    try {
      const response = await get(
        apiUrl +
          "vehicle?limit=" +
          itemsPerPage +
          "&skip=" +
          itemOffset * itemsPerPage +
          "&from_gate_in=" +
          fGateIn +
          "&to_gate_in=" +
          tGateIn +
          "&from_gate_out=" +
          fGateOut +
          "&to_gate_out=" +
          tGateOut +
          "&department_id=" +
          deptId +
          "&location_id=" +
          locId +
          "&fromCreatedDate=" +
          fDate +
          "&toCreatedDate=" +
          tDate +
          "&type=" +
          activeButton +
          "&search=" +
          encodeURIComponent(term) +
          "&sortByField=" +
          sortByField +
          "&sortBy=" +
          sortBy,
      )
        .then(async (response) => {
          if (response.data.status === true) {
            setTotalCount(response.data.total_rec ?? 0);
            setPageCount(response.data.totalPages);
            setVehicles(response.data.vehicles);
            console.log("Page count", pageCount);
            setData({
              gateInCount: response.data.gateInCount,
              gateOutCount: response.data.gateOutCount,
              scheduleCount: response.data.scheduleCount,
              schedulePercentage: response.data.schedulePercentage,
              gateInPercentage: response.data.gateInPercentage,
              gateOutPercentage: response.data.gateOutPercentage,
            });
            setApproveCount(response.data.approvedCount ?? 0);
            setGateInCount(response.data.gateInTabCount ?? 0);
            setSchedulesCount(response.data.scheduleTabCount ?? 0);
            setQueueCount(response.data.queueCount ?? 0);
            setCheckListCount(response.data.checkListFailedCount ?? 0);
            setCompletedCount(response.data.completedCount ?? 0);
            setRejectedCount(response.data.rejectedCount ?? 0);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 400) {
            }
          }
        });
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  //filter list api
  const getFilterListData = async () => {
    getListData(term);
  };

  useEffect(() => {
    getLocationFilter();
    getDepartmentFilter();
  }, []);

  const getLocationFilter = async () => {
    try {
      const response = await getLocationFilterApi();
      if (response.success === true) {
        setLocations(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getDepartmentFilter = async () => {
    try {
      const response = await getDepartmentFilterApi();
      if (response.success === true) {
        setDepartments(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  useEffect(() => {
    if (selectedStatus !== "") {
      setChecklistFailedAdminModal(true);
    }
  }, [selectedStatus]);

  const onApprovedCheckList = async () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate("approve");
  };
  const onRejectedCheckList = () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate("reject");
  };
  const checkListFailsUpdate = async (status) => {
    try {
      const response = await checkListFailsUpdateApi(
        vehicleDetails.id,
        status,
        "vehicle",
      );
      if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        getListData(term);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const gateInApprovedCheckList = async (id) => {
    try {
      const response = await vehicleGateInApprovedCheckListApi(
        id,
        "vehicle",
        invoiceNumber,
        remarks,
      );
      if (response.data.status === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
        if (imageList.length > 0) {
          uploadAttachment(id, imageList);
        }
        closeModal();

        getListData(term);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const uploadAttachment = async (id, imageList) => {
    const response = await uploadGateInOutAttachmentApi(id, {
      type: "vehicle",
      images: imageList,
    });
    if (response.status === 200) {
      setImageList([]);
    }
  };
  const onApproveQueue = async (response) => {
    setShowQueueApproveModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();

    getListData(term);
  };
  const onApproveQueueAndGateIn = async (response) => {
    setShowQueueApproveModal(false);

    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getListData(term);
  };

  const onProceedGateOut = async (
    itemList,
    selectedCustomer,
    reasonLabel,
    reasonOption,
    attachments,
    remarks,
  ) => {
    gateOut(
      itemList,
      selectedCustomer,
      reasonLabel,
      reasonOption,
      attachments,
      remarks,
    );
  };

  const gateOut = async (
    itemList,
    selectedCustomer,
    reasonLabel,
    reasonOption,
    attachments,
    remarks,
  ) => {
    try {
      const response = await gateOutVehicleApi({
        vehicle_id: vehicleDetails.id,
        items: itemList.map((item) => ({
          item_name: DOMPurify.sanitize(item.item_name),
          quantity: DOMPurify.sanitize(item.quantity),
          description: DOMPurify.sanitize(item.description),
        })),
        customers: selectedCustomer
          ?.filter((item) => item.value !== "")
          .map((item) => item.value),
        attachment: attachments.length ?? 0,
        gate_out_remarks: remarks,
        reason: reasonOption?.value || "",
        reason_type: reasonLabel,
      });
      setSnackbarMessage(response?.data?.message);
      setSnackbarStatus(response?.data?.status);
      handleSnackbarShow();
      if (response.data.status === true) {
        setShowGateOutDetails(false);

        if (attachments.length > 0) {
          uploadAttachment(vehicleDetails.id, attachments);
        }
        getListData(term);
      }

      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const queueStatusUpdate = async (id) => {
    const payload = {
      id: id,
      status: "",
      checklists: [],
      queue_status: "Rejected", // Approved, Rejected
      validate_check_list: true, // true, fasle
      check_list_status: "", //pending, approve
      type: "vehicle", // pending, approved, rejected
      items: [],
    };
    try {
      const response = await queueStatusUpdateApi(payload);
      if (response.statusCode === 400) {
      } else {
        if (response?.data.status === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.status);
          handleSnackbarShow();
          getListData(term);
        } else {
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const listCount = (menu) => {
    switch (menu) {
      case "Queue":
        return queueCount;
      case "Approved":
        return approveCount;
      case "Checklist Failed":
        return checkListCount;

      case "Gate In":
        return gateInCount;
      case "Scheduled":
        return schedulesCount;
      case "Rejected":
        return rejectedCount;
      case "Completed":
        return completedCount;
      default:
        return 0;
    }
  };

  const isFieldEnabled = (field) => {
    if (activeButton === "queue" && field === "Registered Date") return true;
    if (activeButton === "approved" && field === "Approved Date") return true;
    if (
      activeButton === "checklist-failed" &&
      field === "Checklist Failed Date"
    )
      return true;
    if (activeButton === "schedule" && field === "Scheduled Date") return true;
    if (activeButton === "rejected" && field === "Rejected Date") return true;
    return listingColumns
      .filter(
        (option) =>
          ((activeButton === "queue" ||
            activeButton === "approved" ||
            activeButton === "checklist-failed" ||
            activeButton === "schedule" ||
            activeButton === "rejected") &&
            option.value !== "in_time" &&
            option.value !== "out_time" &&
            option.value !== "responsible_pername") ||
          (activeButton === "checklist-failed" &&
            option.value !== "in_time" &&
            option.value !== "out_time") ||
          (activeButton === "gatein" &&
            option.value !== "out_time" &&
            option.value !== "responsible_pername") ||
          (activeButton === "completed" &&
            option.value !== "responsible_pername"),
      )
      .some((item) => item.status === true && item.label === field);
  };
  const dropdownRef = useRef(null);
  const toggleColumn = (key) => {
    const tempColumn = [...listingColumns];
    const index = tempColumn.findIndex((column) => column.value === key);
    if (index > -1) {
      tempColumn[index].status = !tempColumn[index].status;
    }
    setListingColumns(tempColumn);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCustomColumPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [photo, setPhoto] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const openInModal = () => {
    setCapturedImage(null);
    setPhoto(true);
  };

  const closeInModal = () => {
    stopCamera();
    setPhoto(false);
    setCapturedImage(null);
  };

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    } catch (err) {
      console.error("Camera access error:", err);
      alert("Please allow camera access.");
      setPhoto(false);
    }
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, 420, 250);
    const imageDataURL = canvas.toDataURL("image/png");
    setCapturedImage(imageDataURL);
    stopCamera();
  };

  const retake = () => {
    setCapturedImage(null);
    startCamera(); // Re-open the camera
  };

  useEffect(() => {
    if (photo && !capturedImage) startCamera();
    return () => stopCamera();
  }, [photo]);

  //over

  //

  const getEnabledField = async (id, gate_id, department_id) => {
    const data = {
      type: "Vehicle",
      gate_id: gate_id ?? "",
      department_id: department_id ?? "",
    };
    try {
      const response = await getEnabledFieldApi(data);
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? []);
        if (
          response?.enabled_fields.some(
            (item) =>
              item === "Gate-in attachment" ||
              item === "Invoice number" ||
              item === "Gate-in remarks",
          )
        ) {
          setIsGateInAttachmentRequired(
            response?.mandatory_fields.some(
              (item) => item === "Gate-in attachment",
            ) ?? false,
          );
          setIsGateInInvoiceRequired(
            response?.mandatory_fields.some(
              (item) => item === "Invoice number",
            ) ?? false,
          );
          setIsGateInRemarksRequired(
            response?.mandatory_fields.some(
              (item) => item === "Gate-in remarks",
            ) ?? false,
          );
          openModal();
        } else {
          gateInApprovedCheckList(id);
        }
        // setEnabledFields(response?.enabled_fields ?? {});
        // setMandatoryFields(response?.mandatory_fields ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        fontFamily: "Epilogue",
      }}
    >
      {showQueueApproveModal && (
        <QueueApproveModal
          fromModule={"Vehicle"}
          visitorDetails={vehicleDetails}
          onApproveQueue={onApproveQueue}
          onApproveQueueAndGateIn={onApproveQueueAndGateIn}
          onCancel={() => {
            setShowQueueApproveModal(false);
          }}
        />
      )}
      {showChecklistFailedAdminModal && (
        <CheckListFailedAdminModal
          moduleId={vehicleDetails.id}
          moduleName={"Vehicle"}
          checkList={vehicleDetails.checklist ?? []}
          visitorName={vehicleDetails.driver_name}
          organization={vehicleDetails.organization}
          visitorPicture={vehicleDetails.profilephoto ?? ""}
          isSaveEnable={false}
          isApprovedEnable={selectedStatus === "Approve" ? true : false}
          onApproved={onApprovedCheckList}
          isRejectedEnable={selectedStatus === "Reject" ? true : false}
          onRejected={onRejectedCheckList}
          onCancel={() => {
            setChecklistFailedAdminModal(false);
            setSelectedStatus("");
          }}
        />
      )}
      {showGateOutDetails && (
        <GateOutModal
          moduleName={"Vehicle"}
          visitorDetails={vehicleDetails}
          onProceed={onProceedGateOut}
          onCancel={() => {
            setShowGateOutDetails(false);
          }}
        />
      )}
      {showGenerateQRCode && (
        <GenerateQRModal
          moduleName={"Vehicle"}
          visitorDetails={vehicleDetails}
          onCancel={() => {
            setShowGenerateQRCode(false);
          }}
        />
      )}
      <div>
        <TopBar currentName="vehicle" />
      </div>
      <div style={{ backgroundColor: "#FFFFFF" }}>
        {isVisible && (
          <div
            className="container-auto mt-3 ms-4 me-4 mb-3"
            style={{ fontFamily: "Epilogue" }}
          >
            <div className="row align-items-center gx-2">
              {" "}
              {/* Reduced horizontal gap */}
              {/* Summary Heading */}
              <div className="col-md-auto d-flex align-items-center">
                <span className="fw-bold me-2 text-center text-md-start">
                  Summary of your
                  <br /> overall entries
                </span>
                <span className="text-muted">
                  <img src={arrow} alt="Arrow" />
                </span>
              </div>
              {/* Gate In Card */}
              <div className="col-sm-3" style={{ width: "20%" }}>
                <div
                  className="card border-1 rounded-3"
                  style={{ borderColor: "#E5E5E5", width: "95%" }}
                >
                  <div className="card-body d-flex align-items-center p-2">
                    <img src={gtin} alt="Gate In" />
                    <div className="ms-2">
                      <h6 className="mb-0 fw-bold">{data.gateInCount}</h6>
                      <small className="text-muted">Gate in</small>
                    </div>
                    <span
                      className="badge ms-auto mb-3 ms-2"
                      style={{ background: "#f7f8f9", color: "#2C8C53" }}
                    >
                      {data.gateInPercentage}%
                    </span>
                  </div>
                </div>
              </div>
              {/* Gate Out Card */}
              <div className="col-sm-3 " style={{ width: "20%" }}>
                <div
                  className="card border-1 rounded-3 "
                  style={{ borderColor: "#E5E5E5", width: "95%" }}
                >
                  <div className="card-body d-flex align-items-center p-2">
                    <img src={gtot} alt="Gate Out" />
                    <div className="ms-2">
                      <h6 className="mb-0 fw-bold">{data.gateOutCount}</h6>
                      <small className="text-muted">Gate out</small>
                    </div>
                    <span
                      className="badge ms-auto mb-3 ms-2"
                      style={{ background: "#f7f8f9", color: "#2C8C53" }}
                    >
                      {data.gateOutPercentage}%
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-auto ms-auto mb-4">
                <button
                  className="btn btn-light rounded d-flex align-items-center justify-content-center"
                  type="button"
                  onClick={() => setIsVisible(false)}
                  style={{
                    width: "65px",
                    background: "#e2f4e9",
                    color: "#252525",
                    fontSize: "12.5px",
                    height: "24px",
                    gap: "5px",
                    borderRadius: "8px",
                    padding: "4px 12px",
                  }}
                >
                  Hide
                  <img
                    src={vectorup}
                    alt="Arrow Up"
                    style={{ width: "8px", height: "8px" }}
                  />
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          className="mt-4 ms-4 me-4"
          style={{
            top: "89px",
            left: "24px",
            gap: "24px",
            fontFamily: "Epilogue",
            fontWeight: "500",
            color: "#172B4D",
          }}
        >
          <div>
            <div
              className="d-flex justify-content-between align-items-center mb-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: 20, fontWeight: "700" }}>
                Vehicles lists
              </div>
              {/* <button onClick={openInModal}>Gate In</button>
              <button onClick={openOutModal}>Gate Out</button> */}

              {!isVisible && (
                <div
                  style={{
                    background: "#e2f4e9",
                    color: "#252525",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "4px 12px",
                    borderRadius: "8px",
                  }}
                >
                  <button
                    className="btn"
                    style={{
                      fontFamily: "Epilogue, sans-serif",
                      fontWeight: "500",
                      fontSize: "12.5px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      textTransform: "capitalize",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0",
                    }}
                    onClick={() => setIsVisible(true)}
                  >
                    Show analytics{" "}
                    <img
                      src={vector}
                      style={{ width: "8px", height: "8px", marginLeft: "6px" }}
                    />{" "}
                  </button>
                </div>
              )}
            </div>

            {/* Buttons Section */}
            <Row>
              <Col className="mt-2" sm={12} lg={8}>
                <div style={{ height: "40px" }}>
                  <div
                    className="d-flex  hide-scroll"
                    style={{ width: "100%" }}
                  >
                    {buttons.map(({ label, value }) => (
                      <button
                        key={value}
                        className="btn rounded-3 me-2"
                        onClick={() => handleButtonClick(value)}
                        style={{
                          backgroundColor:
                            activeButton === value ? "#D6ffe6" : "#f8f8f8",
                          border:
                            activeButton === value
                              ? "1px solid #2c8c53"
                              : "none",
                          padding: "10px 16px",
                          borderRadius: "12px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#172B4D",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {label} {"(" + listCount(label) + ")"}
                      </button>
                    ))}
                  </div>
                </div>
              </Col>
              <Col className="mt-2" sm={12} lg={4}>
                <div style={{ position: "relative" }}>
                  <div
                    className="hide-scroll"
                    style={{
                      height: "50px",
                      /*   display: "flex",
                  justifyContent: isFilterOpen ? "space-between" : "flex-end",
                  alignItems: "center", */
                    }}
                  >
                    {/* Buttons container */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "max-content",
                      }}
                    >
                      {/* Search input/button */}
                      {showInput ? (
                        <div
                          className="input-group rounded-pill me-2"
                          style={{ width: "250px" }}
                        >
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search visitors..."
                            style={{
                              boxShadow: "none",
                              outline: "none",
                              border: "1px solid #dcdfe4",
                            }}
                            onChange={(e) => setTerm(e.target.value)}
                            value={term}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            style={{ borderColor: "#dcdfe4" }}
                            onClick={() => setShowInput(false)}
                          >
                            <img src={search} alt="Search Icon" />
                          </button>
                        </div>
                      ) : (
                        <button
                          className="btn rounded-3 me-2"
                          style={{ borderColor: "#dcdfe4" }}
                          onClick={() => setShowInput(true)}
                        >
                          <img src={search} alt="Search Icon" />
                        </button>
                      )}

                      {/* Other buttons */}
                      <button
                        className="btn rounded-3 me-2"
                        style={{ borderColor: "#dcdfe4" }}
                      >
                        <img src={df} />
                        <select
                          style={{ outline: "none", border: "none" }}
                          onChange={(e) => {
                            const [field, order] = e.target.value.split(" ");
                            setSortByField(field);
                            setSortBy(order);
                          }}
                        >
                          <option value="">Default (data created)</option>
                          <option value="gate_vehicles.driver_name asc">
                            Name (Asc)
                          </option>
                          <option value="gate_vehicles.driver_name desc">
                            Name (Dsc)
                          </option>
                          <option value="gate_vehicles.created_at asc">
                            Date (Oldest)
                          </option>
                          <option value="gate_vehicles.created_at desc">
                            Date (Newest)
                          </option>
                        </select>
                      </button>

                      <button
                        onClick={() => {
                          setShowCustomColumPopup(true);
                        }}
                        className="btn rounded-3 me-2"
                        style={{ borderColor: "#dcdfe4" }}
                      >
                        <img src={cus} /> Customize Table
                      </button>
                      <button
                        className="btn rounded-3"
                        style={{ borderColor: "#dcdfe4" }}
                        data-bs-toggle="offcanvas"
                        data-bs-target="#filterPanel"
                      >
                        <img src={filt} alt="Filter Icon" /> Filter
                      </button>
                    </div>

                    {/* Filter panel */}
                    <div
                      className="offcanvas offcanvas-end"
                      // tabIndex="-1"
                      id="filterPanel"
                      aria-labelledby="filterPanelLabel"
                      style={{
                        background: "#F8F9F9",
                        width: "300px",
                        zIndex: 1050,
                      }}
                      data-bs-backdrop="false"
                      data-bs-keyboard="false"
                    >
                      <div className="offcanvas-header">
                        <h5 id="filterPanelLabel">Filters</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>
                      </div>

                      <div className="offcanvas-body">
                        <form>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              style={{ color: "#172B4D" }}
                            >
                              Location
                            </label>
                            <select
                              className="form-select"
                              style={{ color: "#8790A1" }}
                              value={location}
                              onChange={(e) => setLocation(e.target.value)}
                            >
                              <option value="">-- Select --</option>
                              {locations.map((location) => (
                                <option
                                  key={location.value}
                                  value={location.value}
                                >
                                  {location.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="mb-3">
                            <label
                              className="form-label"
                              style={{ color: "#172B4D" }}
                            >
                              Department
                            </label>
                          </div>
                          <MultiSelectDropDown
                            onDropdownChange={handleDepartmentChange}
                            placeholder={"-- Select Department "}
                            selectedOption={department}
                            staticOptions={departments}
                          />

                          <div className="mb-3">
                            <label
                              className="form-label"
                              style={{ color: "#172B4D" }}
                            >
                              Date Range
                            </label>
                            <DatePicker
                              selectsRange={true}
                              startDate={from_date}
                              endDate={to_date}
                              onChange={(update) => setDateRange(update)}
                              className="form-control"
                              placeholderText="Select"
                            />
                          </div>

                          <div className="row mb-3">
                            {/* Gate In Date Range Picker */}
                            <div className="col-6">
                              <label
                                className="form-label"
                                style={{ color: "#172B4D" }}
                              >
                                Gate In
                              </label>
                              <DatePicker
                                selectsRange={true}
                                startDate={from_gate_in}
                                endDate={to_gate_in}
                                onChange={(update) => setGateInRange(update)}
                                className="form-control"
                                placeholderText="Select"
                              />
                            </div>

                            {/* Gate Out Date Range Picker */}
                            <div className="col-6">
                              <label
                                className="form-label"
                                style={{ color: "#172B4D" }}
                              >
                                Gate Out
                              </label>
                              <DatePicker
                                selectsRange={true}
                                startDate={from_gate_out}
                                endDate={to_gate_out}
                                onChange={(update) => setGateOutRange(update)}
                                className="form-control"
                                placeholderText="Select"
                              />
                            </div>
                          </div>
                        </form>

                        <div className="row p-3 flex justify-content-center mt-5">
                          <button
                            className="col-5 btn rounded-pill me-2"
                            style={{
                              background: "#FFFFFF",
                              borderColor: "#E5E5E5",
                            }}
                            onClick={handleReset}
                          >
                            Reset
                          </button>
                          <button
                            className="col-5 btn rounded-pill btn-success"
                            onClick={getFilterListData}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {showCustomColumPopup && (
                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "40px",
                        right: "-10%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#ffffff",
                        color: "#1E1E1E",
                        padding: "16px",
                        borderRadius: "16px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        zIndex: 1000,
                        alignItems: "end",
                      }}
                    >
                      <div
                        className="font-semibold mb-2"
                        style={{ fontSize: "18px" }}
                      >
                        Select Columns
                      </div>
                      {listingColumns
                        .filter(
                          (option) =>
                            ((activeButton === "queue" ||
                              activeButton === "approved" ||
                              activeButton === "checklist-failed" ||
                              activeButton === "schedule" ||
                              activeButton === "rejected") &&
                              option.value !== "in_time" &&
                              option.value !== "out_time" &&
                              option.value !== "responsible_pername") ||
                            (activeButton === "checklist-failed" &&
                              option.value !== "in_time" &&
                              option.value !== "out_time") ||
                            (activeButton === "gatein" &&
                              option.value !== "out_time" &&
                              option.value !== "responsible_pername") ||
                            (activeButton === "completed" &&
                              option.value !== "responsible_pername"),
                        )
                        .map((col, index) => (
                          <div key={col.value} className="mb-1">
                            <label>
                              <input
                                type="checkbox"
                                checked={col.status}
                                onChange={() => toggleColumn(col.value)}
                              />
                              <span
                                className="ms-2"
                                style={{ fontSize: "16px" }}
                              >
                                {col.label}
                              </span>
                            </label>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>

          {/* Visitors Table */}
          <div className="table-responsive">
            <table className="table table-hover border table-bordered align-middle">
              <thead>
                <tr style={{ fontSize: "13px", textTransform: "capitalize" }}>
                  {isFieldEnabled("S.No") && (
                    <th
                      style={{
                        textAlign: "center",
                        color: "#174b4d",
                        background: "#f8f9f9",
                      }}
                    >
                      S.No
                    </th>
                  )}
                  {isFieldEnabled("Driver Name") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      <img src={frame} className="mb-1" /> Driver Name
                    </th>
                  )}
                  {isFieldEnabled("Gate") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      <img src={gate} className="mb-1" /> Gate
                    </th>
                  )}
                  {isFieldEnabled("Gate In") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      <img src={clock} className="mb-1" /> Gate In
                    </th>
                  )}
                  {isFieldEnabled("Gate Out") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      <img src={clock} className="mb-1" /> Gate Out
                    </th>
                  )}
                  {isFieldEnabled("Vehicle Number") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      <img src={org} className="mb-1" /> Vehicle number
                    </th>
                  )}
                  {isFieldEnabled("Mobile Number") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      <img src={proof} className="mb-1" /> Mobile Number
                    </th>
                  )}
                  {isFieldEnabled("Email") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      <img src={pov} className="mb-1" /> Email
                    </th>
                  )}
                  {isFieldEnabled("Reporting Person") && (
                    <th
                      style={{
                        color: "#174b4d",
                        background: "#f8f9f9",
                      }}
                    >
                      <img src={meet} className="mb-1" /> Reporting Person
                    </th>
                  )}
                  {/* {isFieldEnabled("Registered Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Registered Date
                    </th>
                  )}

                  {isFieldEnabled("Approved Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Approved Date
                    </th>
                  )}

                  {isFieldEnabled("Checklist Failed Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Checklist Failed Date
                    </th>
                  )}

                  {isFieldEnabled("Scheduled Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Scheduled Date
                    </th>
                  )}

                  {isFieldEnabled("Rejected Date") && (
                    <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                      Rejected Date
                    </th>
                  )} */}
                  {/* <th
                    style={{
                      color: "#174b4d",
                      background: "#f8f9f9",
                      width: "100px",
                    }}
                  >
                    <img src={meet} className="mb-1" /> Meeting Person
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="100%" className="text-center py-5">
                      <Loader />
                    </td>
                  </tr>
                ) : vehicles.length === 0 ? (
                  <tr>
                    <td colSpan="100%" className="text-center py-5 text-muted">
                      No records found
                    </td>
                  </tr>
                ) : (
                  vehicles.map((vehicle, index) => (
                  <tr
                    key={index}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                    style={{
                      fontSize: "13px",
                      textTransform: "capitalize",
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate("/vehicle-view", { state: { id: vehicle.id } });
                    }}
                  >
                    {isFieldEnabled("S.No") && (
                      <td
                        className="text-center align-middle"
                        style={{
                          position: "static",
                          overflow: hoveredRow === index ? "visible" : "hidden",
                        }}
                      >
                        {itemOffset * itemsPerPage + (index + 1)}

                        {/* Hover Action Buttons - positioned absolutely relative to the ROW */}
                        {hoveredRow === index &&
                          (vehicle.schedule_update ||
                            vehicle.queue_update ||
                            vehicle.checklist_approve ||
                            vehicle.gate_in ||
                            vehicle.gate_out ||
                            (vehicle.in_time &&
                              !vehicle.out_time &&
                              vehicle.schedule_status !== "Reject")) && (
                            <div className="row-widget">
                              {vehicle.queue_update === true && (
                                <div className="style-justify-center">
                                  <div
                                    className="checklist-reject-btn style-justify-center"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setVehicleDetails(vehicle);
                                      queueStatusUpdate(vehicle.id);
                                    }}
                                  >
                                    Reject
                                  </div>
                                  <div
                                    className="approve-btn style-justify-center px-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setVehicleDetails(vehicle);
                                      setShowQueueApproveModal(true);
                                    }}
                                  >
                                    Approve
                                  </div>
                                </div>
                              )}
                              {vehicle.checklist_approve === true && (
                                <div className="style-justify-center">
                                  <div
                                    className="checklist-reject-btn style-justify-center"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setVehicleDetails(vehicle);
                                      setSelectedStatus("Reject");
                                    }}
                                  >
                                    Reject
                                  </div>
                                  <div
                                    className="approve-btn style-justify-center"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setVehicleDetails(vehicle);
                                      setSelectedStatus("Approve");
                                    }}
                                  >
                                    Approve
                                  </div>
                                </div>
                              )}

                              {vehicle.in_time != null &&
                                vehicle.out_time == null &&
                                vehicle.schedule_status !== "Reject" && (
                                  <div className="">
                                    {/* Generate QR Button */}
                                    <button
                                      className="btn btn-success  rounded-3 btn-sm"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setVehicleDetails(vehicle);
                                        setShowGenerateQRCode(true);
                                      }}
                                    >
                                      Generate QR
                                    </button>
                                  </div>
                                )}
                              {vehicle.gate_in === true && (
                                <button
                                  style={{
                                    border: "none",
                                    backgroundColor: "#2C8C53",
                                    color: "#ffffff",
                                    padding: "6px 16px",
                                    borderRadius: "20px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    position: "relative",
                                    zIndex: 2,
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setSelectedVehicle(vehicle);
                                    getEnabledField(
                                      vehicle.id,
                                      vehicle.gate_id,
                                      vehicle.department_id,
                                    );
                                  }}
                                >
                                  <span className="px-2">Gate In</span>
                                </button>
                              )}
                              {vehicle.gate_out === true && (
                                <button
                                  className="btn rounded-3 btn-success btn-sm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setVehicleDetails(vehicle);
                                    setShowGateOutDetails(true);
                                  }}
                                >
                                  Gate Out
                                </button>
                              )}
                            </div>
                          )}
                      </td>
                    )}
                    {isFieldEnabled("Driver Name") && (
                      <td
                        style={{
                          color: "#172b4d",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "150px",
                        }}
                      >
                        {vehicle.driver_name}
                      </td>
                    )}
                    {isFieldEnabled("Gate") && (
                      <td
                        style={{
                          color: "#172b4d",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "120px",
                        }}
                      >
                        {vehicle.gate}
                      </td>
                    )}
                    {isFieldEnabled("Gate In") && (
                      <td
                        style={{
                          color: "#172b4d",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "120px",
                        }}
                      >
                        {vehicle.in_time}
                      </td>
                    )}
                    {isFieldEnabled("Gate Out") && (
                      <td
                        style={{
                          color: "#172b4d",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "120px",
                        }}
                      >
                        {vehicle.out_time}
                      </td>
                    )}
                    {isFieldEnabled("Vehicle Number") && (
                      <td
                        style={{
                          color: "#172b4d",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "150px",
                        }}
                      >
                        {vehicle.vehicle_number}
                      </td>
                    )}
                    {isFieldEnabled("Mobile Number") && (
                      <td
                        style={{
                          color: "#172b4d",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "120px",
                        }}
                      >
                        {vehicle.mobile_number || "N/A"}
                      </td>
                    )}
                    {isFieldEnabled("Email") && (
                      <td
                        style={{
                          color: "#172b4d",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "160px",
                        }}
                      >
                        {vehicle.email}
                      </td>
                    )}
                    {isFieldEnabled("Reporting Person") && (
                      <td
                        style={{
                          color: "#172b4d",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "160px",
                        }}
                      >
                        {vehicle.responsible_pername}
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {isOpenGateInAttachment && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
                <div
                  style={{
                    width: "500px",
                    height: "fit-content",
                    background: "white",
                    borderRadius: "10px",
                    padding: "20px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
                    position: "relative",
                  }}
                >
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      closeModal();
                    }}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      border: "none",
                      background: "transparent",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    &times;
                  </button>
                  {enabledFields.some(
                    (item) => item === "Gate-in attachment",
                  ) && (
                    <div>
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          marginBottom: "16px",
                        }}
                      >
                        Attachment{" "}
                        {isGateInAttachmentRequired && (
                          <span style={{ color: "#FF4444" }}>*</span>
                        )}
                      </div>
                      <div
                        style={{
                          background: "#F6F7F8",
                          borderRadius: "24px",
                          padding: "12px",
                          marginBottom: "16px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                          }}
                        >
                          <div>
                            <img src={Attachment} style={{ width: "35px" }} />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "700",
                                fontSize: "14px",
                                color: "#172b4d",
                              }}
                            >
                              Choose image or capture image
                            </div>
                            <div
                              style={{
                                fontWeight: "400",
                                fontSize: "12px",
                                color: "#8790A1",
                              }}
                            >
                              JPG, PNG formats only
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              backgroundColor: "#ffffff",
                              border: "1px solid #d4dde7",
                              height: "36px",
                              lineHeight: "100%",
                              borderRadius: "37px",
                              padding: "10px 16px",
                              cursor: "pointer",
                            }}
                          >
                            <img src={Upload} style={{ width: "16px" }} />
                            <span
                              style={{
                                fontWeight: "700",
                                fontSize: "13px",
                                color: "#2C8C53",
                              }}
                            >
                              Upload
                            </span>
                            <input
                              type="file"
                              accept=".jpg,.jpeg,.png"
                              style={{ display: "none" }}
                              multiple
                              onChange={handleUploadImageOut}
                            />
                          </label>

                          <div
                            onClick={openOutModal}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              backgroundColor: "#2C8C53",
                              height: "36px",
                              lineHeight: "100%",
                              borderRadius: "37px",
                              padding: "10px 16px",
                            }}
                          >
                            <div>
                              <img src={Camera} style={{ width: "16px" }} />
                            </div>
                            <div
                              style={{
                                fontWeight: "700",
                                fontSize: "13px",
                                color: "#ffffff",
                              }}
                            >
                              Capture
                            </div>
                          </div>

                          {photoOut && (
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                backgroundColor: "rgba(0, 0, 0, 0.4)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1000,
                              }}
                            >
                              <div
                                style={{
                                  width: "450px",
                                  backgroundColor: "#ffffff",
                                  borderRadius: "16px",
                                  padding: "24px",
                                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                  position: "relative",
                                  height: "fit-content",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "24px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "18px",
                                      color: "#2f3941",
                                    }}
                                  >
                                    Take a photo to confirm Gate In
                                  </div>
                                  <div>
                                    <img
                                      src={close}
                                      onClick={closeOutModal}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </div>
                                </div>

                                <video
                                  ref={videoOutRef}
                                  style={{
                                    borderRadius: "8px",
                                    width: "420px",
                                    height: "250px",
                                    marginBottom: "24px",
                                    backgroundColor: "#000",
                                    objectFit: "cover",
                                  }}
                                />

                                <canvas
                                  ref={canvasOutRef}
                                  width={420}
                                  height={250}
                                  style={{ display: "none" }}
                                ></canvas>
                                <button
                                  onClick={captureImageOut}
                                  style={{
                                    width: "100%",
                                    border: "none",
                                    borderRadius: "100px",
                                    padding: "12px 48px",
                                    backgroundColor: "#2c8c53",
                                    color: "#ffffff",
                                    fontWeight: "700",
                                    fontSize: "16px",
                                    marginBottom: "12px",
                                  }}
                                >
                                  Capture
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {imageList.length > 0 && (
                        <div
                          style={{
                            marginTop: "12px",
                            marginBottom: "16px",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "18px",
                          }}
                        >
                          {imageList.map((img, index) => (
                            <div key={index} style={{ position: "relative" }}>
                              <img
                                src={img}
                                alt={`Preview-${index}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderRadius: "6px",
                                  objectFit: "cover",
                                }}
                              />
                              <div
                                onClick={() => removeImage(index)}
                                style={{
                                  position: "absolute",
                                  top: "-6px",
                                  right: "-6px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  color: "#172b4d",
                                  padding: "2px",
                                  borderRadius: "1000px",
                                  backgroundColor: "#ebebeb",
                                }}
                              >
                                X
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {gateInAttachmentRequired}
                      </span>
                    </div>
                  )}
                  {enabledFields.some((item) => item === "Invoice number") && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        marginBottom: "16px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#172b4d",
                        }}
                      >
                        Invoice Number
                        {isGateInInvoiceRequired && (
                          <span style={{ color: "#FF4444" }}>*</span>
                        )}
                      </div>

                      <div>
                        <input
                          type="text"
                          value={invoiceNumber}
                          onChange={(event) => {
                            setInvoiceNumber(event.target.value);
                          }}
                          placeholder="Enter Invoice Number"
                          style={{
                            width: "100%",
                            borderRadius: "8px",
                            border: "1px solid #d4dde7",
                            padding: "0px 16px",
                            height: "36px",
                          }}
                        />
                      </div>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {gateInInvoiceRequired}
                      </span>
                    </div>
                  )}

                  {enabledFields.some((item) => item === "Gate-in remarks") && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#172b4d",
                        }}
                      >
                        Remarks
                      </div>
                      <div>
                        <textarea
                          value={remarks}
                          onChange={(event) => {
                            setRemarks(event.target.value);
                          }}
                          placeholder="Enter Remarks"
                          style={{
                            width: "100%",
                            borderRadius: "8px",
                            border: "1px solid #d4dde7",
                            padding: "8px 16px",
                            height: "100px",
                            resize: "none",
                            fontWeight: "300",
                            fontSize: "13px",
                            color: "#172b4d",
                          }}
                        />
                      </div>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {gateInRemarksRequired}
                      </span>
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                      marginTop: "24px",
                    }}
                  >
                    <button
                      onClick={() => {
                        if (
                          (isGateInAttachmentRequired === false ||
                            (isGateInAttachmentRequired === true &&
                              imageList.length > 0)) &&
                          (isGateInInvoiceRequired === false ||
                            (isGateInInvoiceRequired === true &&
                              invoiceNumber !== "")) &&
                          (isGateInRemarksRequired === false ||
                            (isGateInRemarksRequired === true &&
                              remarks !== ""))
                        ) {
                          gateInApprovedCheckList(selectedVehicle.id);
                        } else {
                          if (
                            isGateInAttachmentRequired === true &&
                            imageList.length === 0
                          ) {
                            setGateInAttachmentRequired(
                              "Gate In Attachment Required!",
                            );
                          }

                          if (
                            isGateInInvoiceRequired === true &&
                            invoiceNumber === ""
                          ) {
                            setGateInInvoiceRequired("Invoice Required!");
                          }

                          if (
                            isGateInRemarksRequired === true &&
                            remarks === ""
                          ) {
                            setGateInRemarksRequired("Remarks Required!");
                          }
                        } /* else if(isGateInAttachmentRequired===false && imageList.length===0){
                        gateInApprovedCheckList(selectedVehicle.id);
                      } */
                      }}
                      style={{
                        border: "none",
                        borderRadius: "100px",
                        padding: "12px 20px",
                        backgroundColor: "#2c8c53",
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "16px",
                        cursor: "pointer",
                        height: "36px",
                        lineHeight: "100%",
                      }}
                    >
                      Gate In
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          {vehicles.length > 0 && (
            <Row>
              <Col>
                <div className="d-flex align-items-center justify-content-start mx-3">
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#212129",
                    }}
                  >
                    Records per page :
                  </span>
                  <select
                    className="select3"
                    id="perpage"
                    value={itemsPerPage}
                    onChange={(event) => {
                      setItemsPerPage(event.target.value);
                    }}
                    style={{
                      cursor: "pointer",

                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "18.9px",
                      color: "#212129",
                      width: "56px",
                      height: "24px",
                      borderRadius: "10px",
                      border: "0.7px solid #E5E5E5",
                      padding: "0 4px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </Col>
              <Col>
                <div className="d-flex justify-content-end">
                  <ReactPaginate
                    previousLabel={
                      <img src={lar} className="ar3" alt="previous" />
                    }
                    nextLabel={<img src={rar} className="ar3" alt="next" />}
                    breakLabel={"..."}
                    pageCount={pageCount + 1}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
      {/*  */}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={4000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Vehiclelist;

// import React, { useState } from "react";
// import One from "../../assets/svg/One.svg";
// import Two from "../../assets/svg/Two.svg";
// import Three from "../../assets/svg/Three.svg";
// import four from "../../assets/svg/Four.svg";
// import five from "../../assets/svg/Five.svg";
// import six from "../../assets/svg/Six.svg";
// import sev from "../../assets/svg/Sev.svg";
// import Driver from "../../assets/svg/Driver.svg";
// import Check from "../../assets/svg/Check.svg";
// import In from "../../assets/svg/In.svg";
// import Out from "../../assets/svg/Out.svg";
// import Num from "../../assets/svg/Num.svg";
// import Proof from "../../assets/svg/Proof.svg";
// import Visit from "../../assets/svg/Visit.svg";
// import Meeting from "../../assets/svg/Meeting.svg";
// import Big from "../../assets/svg/Big.svg";
// import Door from "../../assets/svg/Door.svg";
// import Doorout from "../../assets/svg/Doorout.svg";
// import Time from "../../assets/svg/Time.svg";
// import TopBar from "../topbar/TopBar";

// const VehiclesList = () => {
//   const [isSearchOpen, setIsSearchOpen] = useState(false);

//   const toggleSearch = () => {
//     setIsSearchOpen((prev) => !prev);
//   };
//   const [isVisible, setIsVisible] = useState(false);

//   const toggleVisibility = () => {
//     setIsVisible(!isVisible);
//   };
//   const [isOpen, setIsOpen] = useState(false);

//   const togglePanel = () => {
//     setIsOpen(!isOpen);
//   };
//   const [activeButton, setActiveButton] = useState(null);

//   const handleClick = (button) => {
//     setActiveButton(button);
//   };

//   const getButtonStyle = (button) => ({
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "8px",
//     fontFamily: "Epilogue",
//     fontWeight: "500",
//     borderRadius: "12px",
//     padding: "10px 16px",
//     backgroundColor: activeButton === button ? "#D6FFE6" : "#F8F8F8",
//     border: "none",
//     cursor: "pointer",
//   });

//   const data = [
//     {
//       driverName: "Sathish Kumar",
//       gateIn: "23-03-2023 05:48 PM",
//       gateOut: "23-03-2023 05:48 PM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Aadhaar Card",
//       purpose: "Business Meeting",
//       meetingPerson: "Sasikumar - CEO",
//     },
//     {
//       driverName: "John Doe",
//       gateIn: "24-03-2023 09:00 AM",
//       gateOut: "24-03-2023 09:00 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Passport",
//       purpose: "Project Kick-Off",
//       meetingPerson: "Emily - Project Manager",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Sathish Kumar",
//       gateIn: "23-03-2023 05:48 PM",
//       gateOut: "23-03-2023 05:48 PM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Aadhaar Card",
//       purpose: "Business Meeting",
//       meetingPerson: "Sasikumar - CEO",
//     },
//     {
//       driverName: "Sathish Kumar",
//       gateIn: "23-03-2023 05:48 PM",
//       gateOut: "23-03-2023 05:48 PM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Aadhaar Card",
//       purpose: "Business Meeting",
//       meetingPerson: "Sasikumar - CEO",
//     },
//     {
//       driverName: "Sathish Kumar",
//       gateIn: "23-03-2023 05:48 PM",
//       gateOut: "23-03-2023 05:48 PM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Aadhaar Card",
//       purpose: "Business Meeting",
//       meetingPerson: "Sasikumar - CEO",
//     },
//     {
//       driverName: "John Doe",
//       gateIn: "24-03-2023 09:00 AM",
//       gateOut: "24-03-2023 09:00 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Passport",
//       purpose: "Project Kick-Off",
//       meetingPerson: "Emily - Project Manager",
//     },
//     {
//       driverName: "John Doe",
//       gateIn: "24-03-2023 09:00 AM",
//       gateOut: "24-03-2023 09:00 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Passport",
//       purpose: "Project Kick-Off",
//       meetingPerson: "Emily - Project Manager",
//     },
//     {
//       driverName: "John Doe",
//       gateIn: "24-03-2023 09:00 AM",
//       gateOut: "24-03-2023 09:00 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Passport",
//       purpose: "Project Kick-Off",
//       meetingPerson: "Emily - Project Manager",
//     },
//   ];
//   return (
//     <div style={{ display: "flex", flexDirection: "column" }}>
//       <div>
//         <TopBar />
//       </div>

//       <div style={{ fontFamily: "Epilogue" }}>
//         <div style={{padding:'24px'}}>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "end",
//             }}
//           >
//             <div>
//               {/* Toggle Button */}
//               <div>
//                 <div
//                   onClick={toggleVisibility}
//                   style={{
//                     fontFamily: "Epilogue",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     justifyContent: "end",
//                     backgroundColor: "#E6F4EA",
//                     borderRadius: "8px",
//                     padding: "4px 6px",
//                     whiteSpace: "nowrap", // Ensure the text doesn't break
//                     cursor: "pointer",
//                     border: "none",
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: "12px",
//                       color: "#212121",
//                       fontWeight: "500",
//                       whiteSpace: "nowrap", // Keep text in one line
//                     }}
//                   >
//                     {isVisible ? "Hide" : "Show analytics"}
//                   </span>
//                   <span
//                     style={{
//                       fontSize: "16px",
//                       color: "#212121",
//                       marginLeft: "8px",
//                       transform: isVisible ? "rotate(180deg)" : "rotate(0deg)",
//                       transition: "transform 0.3s ease",
//                     }}
//                   >
//                     ▾
//                   </span>
//                 </div>
//               </div>

//               {/* Collapsible Content */}
//               {isVisible && (
//                 <div
//                   style={{
//                     fontFamily: "Epilogue",
//                     marginBottom: "25px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {/* Summary Heading */}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "10px",
//                       }}
//                     >
//                       <span style={{ color: "#172B4D" }}>
//                         Summary of your <br /> overall entries
//                       </span>
//                       <img src={Big} alt="Arrow" />
//                     </div>

//                     {/* Cards Section */}
//                     <div style={{ display: "flex", gap: "20px" }}>
//                       {[
//                         {
//                           icon: Door,
//                           count: 347,
//                           label: "Gate in",
//                           color: "#FFFFFF",
//                         },
//                         {
//                           icon: Doorout,
//                           count: 450,
//                           label: "Gate out",
//                           color: "#FFFFFF",
//                         },
//                         {
//                           icon: Time,
//                           count: 64,
//                           label: "Scheduled",
//                           color: "#FFFFFF",
//                         },
//                       ].map((card, index) => (
//                         <div
//                           key={index}
//                           style={{
//                             width: "200px",
//                             padding: "12px",
//                             borderRadius: "12px",
//                             backgroundColor: card.color,
//                             border: "1px solid #E5E5E5",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "space-between",
//                           }}
//                         >
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: "10px",
//                             }}
//                           >
//                             <img src={card.icon} alt={card.label} />
//                             <div>
//                               <h6 style={{ margin: 0, fontWeight: "bold" }}>
//                                 {card.count}
//                               </h6>
//                               <small style={{ color: "#6B7280" }}>
//                                 {card.label}
//                               </small>
//                             </div>
//                           </div>
//                           <span
//                             style={{
//                               backgroundColor: "#f7f8f9",
//                               color: "#2C8C53",
//                               padding: "4px 8px",
//                               borderRadius: "12px",
//                               fontSize: "12px",
//                               fontWeight: "500",
//                             }}
//                           >
//                             +23%
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//           <div
//             style={{
//               textAlign:'start',
//               fontSize: "20px",
//               color: "#1D2B4F",
//               fontWeight: "700",
//             }}
//           >
//             Vehicles list
//           </div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 marginBottom: "20px",
//                 marginTop: "20px",
//               }}
//             >
//               {/* Queue Button */}
//               <button
//                 style={getButtonStyle("Queue")}
//                 onClick={() => handleClick("Queue")}
//               >
//                 <img
//                   src={One}
//                   alt="Queue Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Queue
//               </button>

//               {/* Approved Button */}
//               <button
//                 style={getButtonStyle("Approved")}
//                 onClick={() => handleClick("Approved")}
//               >
//                 <img
//                   src={Two}
//                   alt="Approved Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Approved
//               </button>

//               {/* Checklist Failed Button */}
//               <button
//                 style={{
//                   ...getButtonStyle("Checklist Failed"),
//                   width: "156px",
//                   whiteSpace: "nowrap",
//                 }}
//                 onClick={() => handleClick("Checklist Failed")}
//               >
//                 <img
//                   src={Three}
//                   alt="Checklist Failed Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Checklist Failed
//               </button>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: "10px",
//                 marginLeft: "100px",
//                 alignItems: "center",
//                 transition: "margin-right 0.3s ease",
//                 marginRight: isOpen ? "360px" : "0",
//               }}
//             >
//               {/* Circle Button */}
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 {/* Search Bar (Left Side) */}
//                 {isSearchOpen && (
//                   <input
//                     type="text"
//                     placeholder="Search Vehicles"
//                     style={{
//                       width: "200px",
//                       height: "40px",
//                       borderRadius: "8px",
//                       border: "1px solid #ccc",
//                       fontSize: "14px",
//                       marginRight: "10px",
//                       transition: "width 0.3s ease",
//                     }}
//                   />
//                 )}

//                 {/* Search Icon Button */}
//                 <button
//                   onClick={toggleSearch}
//                   style={{
//                     width: "36px",
//                     height: "36px",
//                     border: "0.6px solid #ccc",
//                     borderRadius: "50%",
//                     backgroundColor: "white",
//                     cursor: "pointer",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <img
//                     src={four}
//                     alt="Queue Icon"
//                     style={{ width: "22px", height: "22px" }}
//                   />
//                 </button>
//               </div>
//               {/* Default Button */}
//               <button
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "5px",
//                   padding: "8px 15px",
//                   borderRadius: "10px",
//                   border: "1px solid #ccc",
//                   backgroundColor: "white",
//                   fontFamily: "Epilogue",
//                   fontWeight: "500",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img
//                   src={five}
//                   alt="Queue Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Default (Date Created)
//               </button>

//               {/* Customize Table Button */}
//               <button
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "5px",
//                   padding: "8px 15px",
//                   borderRadius: "10px",
//                   fontFamily: "Epilogue",
//                   fontWeight: "500",
//                   border: "1px solid #ccc",
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img
//                   src={six}
//                   alt="Queue Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Customize Table
//               </button>

//               <button
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "5px",
//                   padding: "8px 15px",
//                   borderRadius: "10px",
//                   border: "1px solid #dcdfe4",
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                 }}
//                 onClick={togglePanel}
//               >
//                 <img
//                   src={sev}
//                   alt="Filter Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 {isOpen ? "Close Filter" : "Filter"}
//               </button>

//               {/* Sliding Panel */}
//               <div
//                 style={{
//                   position: "fixed",
//                   top: "0",
//                   right: isOpen ? "0" : "-300px",
//                   width: "250px",
//                   height: "100vh",
//                   backgroundColor: "#F8F9F9",
//                   boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
//                   transition: "right 0.3s ease",
//                   zIndex: 1000,
//                   padding: "20px",
//                 }}
//               >
//                 {/* Header */}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     marginBottom: "20px",
//                   }}
//                 >
//                   <h2
//                     style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}
//                   >
//                     Filters
//                   </h2>
//                   <button
//                     onClick={togglePanel}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       cursor: "pointer",
//                       fontSize: "18px",
//                     }}
//                   >
//                     ✖
//                   </button>
//                 </div>

//                 {/* Form Fields */}
//                 {["Location", "Department"].map((label) => (
//                   <div
//                     key={label}
//                     style={{ marginBottom: "16px", color: "#172B4D" }}
//                   >
//                     <label
//                       style={{
//                         display: "block",
//                         marginBottom: "8px",
//                         color: "#6B7280",
//                         fontSize: "14px",
//                       }}
//                     >
//                       {label}
//                     </label>
//                     <select
//                       style={{
//                         width: "100%",
//                         padding: "10px",
//                         borderRadius: "8px",
//                         border: "1px solid #ccc",
//                         backgroundColor: "white",
//                         fontSize: "14px",
//                         color: "#6B7280",
//                       }}
//                     >
//                       <option>Select</option>
//                     </select>
//                   </div>
//                 ))}

//                 {/* Date Range */}
//                 <div style={{ marginBottom: "16px" }}>
//                   <label
//                     style={{
//                       display: "block",
//                       marginBottom: "8px",
//                       color: "#6B7280",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Date range
//                   </label>
//                   <button
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       border: "1px solid #E5E5E5",
//                       backgroundColor: "#ffffff",
//                       color: "#2c8c53",
//                       fontSize: "14px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Select
//                   </button>
//                 </div>

//                 {/* Gate In & Out */}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     marginBottom: "16px",
//                   }}
//                 >
//                   {["Gate in", "Gate out"].map((label) => (
//                     <div key={label} style={{ width: "48%" }}>
//                       <label
//                         style={{
//                           display: "block",
//                           marginBottom: "8px",
//                           color: "#6B7280",
//                           fontSize: "14px",
//                         }}
//                       >
//                         {label}
//                       </label>
//                       <button
//                         style={{
//                           width: "100%",
//                           padding: "10px",
//                           borderRadius: "8px",
//                           border: "1px solid #E5E5E5",
//                           backgroundColor: "#ffffff",
//                           color: "#2c8c53",
//                           fontSize: "14px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         Select
//                       </button>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Status */}
//                 <div style={{ marginBottom: "16px" }}>
//                   <label
//                     style={{
//                       display: "block",
//                       marginBottom: "8px",
//                       color: "#6B7280",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Status
//                   </label>
//                   <select
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       border: "1px solid #ccc",
//                       backgroundColor: "white",
//                       fontSize: "14px",
//                       color: "#6B7280",
//                     }}
//                   >
//                     <option>Select</option>
//                   </select>
//                 </div>

//                 {/* Buttons */}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     marginTop: "20px",
//                   }}
//                 >
//                   <button
//                     style={{
//                       width: "116px",
//                       height: "44px",
//                       borderRadius: "45px",
//                       backgroundColor: "#FFFFFF",
//                       border: "1px solid #E5E5E5",
//                       color: "#212121",
//                       cursor: "pointer",
//                       padding: "10px 32px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "11px",
//                     }}
//                   >
//                     Reset
//                   </button>
//                   <button
//                     style={{
//                       width: "116px",
//                       height: "44px",
//                       borderRadius: "45px",
//                       backgroundColor: "#2c8c53",
//                       color: "#ffffff",
//                       border: "none",
//                       cursor: "pointer",
//                       padding: "10px 32px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "11px",
//                     }}
//                   >
//                     Apply
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div
//             style={{
//               padding: "20px",
//               marginTop: "-15px",
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "13px",
//                 textAlign: "left",
//                 color: "#172B4D",
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     backgroundColor: "#E5E5E5",
//                     borderBottom: "1px solid #ddd",
//                   }}
//                 >
//                   {[
//                     { icon: Check, label: "", style: { marginLeft: "6px" } },
//                     { icon: Driver, label: "Driver Name" },
//                     { icon: In, label: "Gate In" },
//                     { icon: Out, label: "Gate Out" },
//                     {
//                       icon: Num,
//                       label: "Vehicle Number",
//                     },
//                     { icon: Proof, label: "Proof" },
//                     {
//                       icon: Visit,
//                       label: "Purpose Of Visit",
//                     },
//                     {
//                       icon: Meeting,
//                       label: "Meeting Person",
//                     },
//                   ].map((item, index) => (
//                     <th
//                       key={index}
//                       style={{
//                         padding: "8px",
//                         color: "#172B4D",
//                         backgroundColor: "#F1F2F4",
//                         textAlign: "left",
//                         borderRight: index === 7 ? "none" : "1px solid #ddd",
//                       }}
//                     >
//                       {item.label === "" ? (
//                         <span style={item.style}>
//                           <img
//                             src={item.icon}
//                             alt="Check"
//                             style={{ width: "16px", height: "16px" }}
//                           />
//                         </span>
//                       ) : (
//                         <span
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "8px",
//                           }}
//                         >
//                           <img
//                             src={item.icon}
//                             alt={item.label}
//                             style={{ width: "16px", height: "16px" }}
//                           />
//                           {item.label}
//                         </span>
//                       )}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {data.map((row, index) => (
//                   <tr
//                     key={index}
//                     style={{
//                       borderBottom: "1px solid #ddd",
//                       transition: "background-color 0.3s ease",
//                     }}
//                     onMouseEnter={(e) =>
//                       (e.currentTarget.style.backgroundColor = "#F1F2F4")
//                     }
//                     onMouseLeave={(e) =>
//                       (e.currentTarget.style.backgroundColor = "white")
//                     }
//                   >
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid  #F1F2F4",
//                       }}
//                     >
//                       <input type="checkbox" />
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.driverName}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.gateIn}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.gateOut}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.vehicleNumber}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.proof}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.purpose}
//                     </td>
//                     <td
//                       style={{
//                         marginTop: "10px",
//                         marginLeft: "10px",
//                         backgroundColor: "#F1F2F4",
//                         borderRadius: "8px",
//                         display: "inline-flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         textAlign: "center",
//                         fontSize: "12px",
//                         whiteSpace: "nowrap",
//                         padding: "4px 8px",
//                         height: "15px",
//                       }}
//                     >
//                       {row.meetingPerson}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 fontFamily: "Epilogue",
//                 fontWeight: "500",
//                 marginTop: "10px",
//                 alignItems: "center",
//               }}
//             >
//               <span style={{ fontSize: "14px" }}>
//                 Records per page:
//                 <select
//                   style={{
//                     marginLeft: "5px",
//                     padding: "5px",
//                     borderRadius: "5px",
//                     border: "1px solid #ddd",
//                   }}
//                 >
//                   <option>10</option>
//                   <option>20</option>
//                   <option>50</option>
//                 </select>
//               </span>
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "flex-end",
//               transform: "translateY(-40px)",
//             }}
//           >
//             <nav className="me-4">
//               <ul
//                 className="pagination"
//                 style={{
//                   display: "flex",
//                   listStyle: "none",
//                   padding: 0,
//                   margin: 0,
//                 }}
//               >
//                 <li className="page-item disabled">
//                   <button
//                     className="me-2"
//                     style={{
//                       width: "25px",
//                       height: "25px",
//                       borderRadius: "50%",
//                       border: "none",
//                       outline: "none",
//                       background: "none",
//                       cursor: "pointer",
//                     }}
//                   >
//                     &lt;
//                   </button>
//                 </li>

//                 {[1, 2, 3, 4, 5].map((num, index) => (
//                   <li
//                     className={`page-item ${num === 1 ? "active" : ""}`}
//                     key={index}
//                   >
//                     <button
//                       className="me-2"
//                       style={{
//                         width: "25px",
//                         height: "25px",
//                         borderRadius: "50%",
//                         background: num === 1 ? "#2c8c53" : "none",
//                         color: num === 1 ? "#ffffff" : "#172b4d",
//                         fontFamily: "Epilogue",
//                         border: "none",
//                         outline: "none",
//                         cursor: "pointer",
//                       }}
//                     >
//                       {num}
//                     </button>
//                   </li>
//                 ))}

//                 <li className="page-item">
//                   <button
//                     className="me-2"
//                     style={{
//                       width: "25px",
//                       height: "25px",
//                       borderRadius: "50%",
//                       border: "none",
//                       outline: "none",
//                       background: "none",
//                       cursor: "default",
//                     }}
//                   >
//                     ...
//                   </button>
//                 </li>

//                 <li className="page-item">
//                   <button
//                     className="me-2"
//                     style={{
//                       width: "25px",
//                       height: "25px",
//                       borderRadius: "50%",
//                       border: "none",
//                       outline: "none",
//                       background: "none",
//                       cursor: "pointer",
//                     }}
//                   >
//                     &gt;
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VehiclesList;
